import { createTheme } from "@mui/material/styles";
import EventsEmitter from "events/EventsEmitter";
import { defaultBorderColor, defaultBorder } from "./common";

const lightTheme = createTheme({
    palette: {
        primary: {
            main: "#3dabe6",
            contrastText: "#ffffff",
        },
        secondary: {
            main: "rgb(255, 194, 72)",
        },
        background: {
            default: "#f0f0f0",
            paper: "#02578E", //!important
        },
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    border: "none",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    minWidth: 20,
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paperAnchorDockedLeft: {
                    borderRight: defaultBorder,
                },
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    backgroundColor: defaultBorderColor,
                },
            },
        },
        MuiMenu: {
            styleOverrides: {
                list: {
                    backgroundColor: "#ffffff",
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                colorPrimary: {
                    color: "#000",
                    backgroundColor: "#f0f0f0",
                },
            },
        },
        MuiCircularProgress: {
            styleOverrides: {
                colorPrimary: {
                    color: "red",
                },
            },
        },
    },
});

const darkTheme = createTheme({
    palette: {
        primary: {
            main: "#fff",
            contrastText: "#000",
        },
        secondary: {
            main: "rgba(255, 255, 255, 0.7)",
        },
        background: {
            default: "#303030",
            paper: "#424242",
        },
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    border: "none",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    minWidth: 20,
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paperAnchorDockedLeft: {
                    borderRight: defaultBorder,
                },
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    backgroundColor: "#303030",
                },
            },
        },
        MuiMenu: {
            styleOverrides: {
                list: {
                    backgroundColor: "#303030",
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                colorPrimary: {
                    backgroundColor: "#303030",
                },
            },
        },
        MuiCircularProgress: {
            styleOverrides: {
                colorPrimary: {
                    color: "#1A90FF !important",
                },
            },
        },
    },
});

class ThemeHandler {
    static theme = "light";
    constructor() {
        EventsEmitter.on("changeTheme", ThemeHandler.setTheme);
    }

    destructor() {
        console.log(`${ThemeHandler.theme} is destroyed`);
    }

    static setTheme(theme: string) {
        ThemeHandler.theme = theme;
    }

    getUserTheme() {
        const userTheme: string = ThemeHandler.theme;
        if (!userTheme || userTheme === "light") {
            return lightTheme;
        } else {
            return darkTheme;
        }
    }
}

export const themeHandler = new ThemeHandler();
